<template>
    <div class="page products">
        <div class="main-icon" v-show="onPage"></div>
        <router-view />
    </div>
</template>

<script>
export default {
    computed: {
        onPage() {
            return this.$route.name == 'products';
        }
    }
};
</script>

<style></style>
